module.exports = __webpack_public_path__ + "roboto-v15-latin-300.c3547b2ec6f5eb324b44.eot";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/roboto-v15-latin-300.eot
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-300.eot
// module chunks = 2